import { render, staticRenderFns } from "./AppAnnotationPart8.vue?vue&type=template&id=3d63d5bc&scoped=true"
import script from "./AppAnnotationPart8.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart8.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart8.vue?vue&type=style&index=0&id=3d63d5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d63d5bc",
  null
  
)

export default component.exports